import * as yup from "yup";
import regEx from "../../../../../shared/validations/regularExpression";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([
    "oldPassword",
    "newPassword",
    "confirmPassword",
  ]);

  let customSchema = yup.object().shape({});

  return defaultSchema.concat(customSchema);
};

export const customizeProfileValidationSchema = (editStatus?: boolean) => {
  let defaultSchema: any = getValidationSchema([
    "name",
    "email",
    "phone",
    "gender",
    "designation",
  ]);

  let customSchema = yup.object().shape({
    secondaryEmail: yup
      .string()
      .trim("Email address cannot include leading and trailing spaces")
      .email("Invalid Email address format")
      .matches(regEx.email, "Invalid Email address format")
      .min(2, "Email address must be more than 2 characters")
      .max(50, "Email address cannot exceed more than 30 characters"),
    designation: yup
      .string()
      .required("Designation is required")
      .matches(/^[A-Za-z\s]+$/, "Designation must contain only letters")
      .min(2, "Designation must be at least 2 characters")
      .max(10, "Designation must be at most 10 characters"),
  });

  return defaultSchema.concat(customSchema);
};
